//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertMSToDHMS } from '../../../components/helpers.js'

import DateTimeField from '../../../components/Field/DateTimeField.vue'

export default {
  components: {
    DateTimeField
  },
  props: {
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      convertMSToDHMS: convertMSToDHMS
    }
  },
  computed: {
    serviceDuration: function () {
      return this.request.endServiceTime != null && this.request.startServiceTime != null && this.request.endServiceTime >= this.request.startServiceTime ? this.request.endServiceTime - this.request.startServiceTime : this.request.serviceDuration
    },
    vehicleOdometerDistance: {
      get: function () {
        if (this.request.vehicleOdometerFaulty) {
          return this.request.vehicleOdometerDistance
        } else {
          return !!this.request.startVehicleOdometerValue && !!this.request.endVehicleOdometerValue && this.request.endVehicleOdometerValue >= this.request.startVehicleOdometerValue ? this.request.endVehicleOdometerValue - this.request.startVehicleOdometerValue : null
        }
      },
      set: function (value) {
        if (this.request.vehicleOdometerFaulty) {
          this.request.vehicleOdometerDistance = value
        }
      }
    }
  },
  watch: {
    'request.vehicleOdometerFaulty': function () {
      if (this.request.vehicleOdometerFaulty) {
        this.request.vehicleOdometerDistance = null
        this.request.startVehicleOdometerValue = null
        this.request.endVehicleOdometerValue = null
      }
      this.validateFields(['vehicleOdometerDistance'])
      this.validateFields(['startVehicleOdometerValue'])
      this.validateFields(['endVehicleOdometerValue'])
    }
  },
  methods: {
    validateFields: function (validFieldKeys) {
      validFieldKeys.forEach(validFieldKey => {
        if (this.$refs[validFieldKey]) {
          this.$refs[validFieldKey].validate()
        }
      })
    }
  }
}

